module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "text-right w-100 mt-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetFilters()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("mdi-reload")]), _vm._v(" Reset\n          ")], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold mt-3 pb-3"
  }, [_vm._v("Inclusive of relevant topics (%)")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "ticks": "always",
      "step": "10",
      "thumb-size": 24,
      "thumb-label": "always"
    },
    model: {
      value: (_vm.settings.relevantKeywords),
      callback: function($$v) {
        _vm.$set(_vm.settings, "relevantKeywords", $$v)
      },
      expression: "settings.relevantKeywords"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticClass: "pr-2",
    staticStyle: {
      "min-width": "50%"
    }
  }, [_c('p', {
    staticClass: "body-2 mb-3"
  }, [_c('v-icon', [_vm._v("mdi-account")]), _vm._v(" Influencer")], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Influencer",
      "multiple": ""
    },
    model: {
      value: (_vm.settings.influencerGeos),
      callback: function($$v) {
        _vm.$set(_vm.settings, "influencerGeos", $$v)
      },
      expression: "settings.influencerGeos"
    }
  })], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "body-2 mb-3"
  }, [_c('v-icon', [_vm._v("mdi-account-multiple")]), _vm._v(" Audience")], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Audience",
      "multiple": ""
    },
    model: {
      value: (_vm.settings.audGeos),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGeos", $$v)
      },
      expression: "settings.audGeos"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "90px",
      "margin-top": "5px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.percentOptions
    },
    model: {
      value: (_vm.settings.audGeoPercent),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGeoPercent", $$v)
      },
      expression: "settings.audGeoPercent"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticStyle: {
      "min-width": "50%"
    }
  }, [_c('p', {
    staticClass: "body-2 mb-2"
  }, [_c('v-icon', [_vm._v("mdi-account")]), _vm._v(" Influencer")], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: (_vm.settings.infGender),
      callback: function($$v) {
        _vm.$set(_vm.settings, "infGender", $$v)
      },
      expression: "settings.infGender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Male or Female",
      "value": "KNOWN"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Male",
      "value": "MALE"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Female",
      "value": "FEMALE"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "body-2 mb-2"
  }, [_c('v-icon', [_vm._v("mdi-account-multiple")]), _vm._v(" Audience")], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: (_vm.settings.audGender),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGender", $$v)
      },
      expression: "settings.audGender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Any",
      "value": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Male",
      "value": "MALE"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Female",
      "value": "FEMALE"
    }
  })], 1), _vm._v(" "), (_vm.settings.audGender) ? _c('v-autocomplete', {
    staticStyle: {
      "max-width": "90px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.percentOptions
    },
    model: {
      value: (_vm.settings.audGenderPercent),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGenderPercent", $$v)
      },
      expression: "settings.audGenderPercent"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold"
  }, [_vm._v("Followers")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n                From\n                "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.from
    },
    model: {
      value: (_vm.settings.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.settings.followers, "from", $$v)
      },
      expression: "settings.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                To\n                "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.to
    },
    model: {
      value: (_vm.settings.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.settings.followers, "to", $$v)
      },
      expression: "settings.followers.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.saveSettings()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-094b4606"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/KeywordSearch/SettingsModal.vue
// module id = 1991
// module chunks = 0